import React, { useMemo } from 'react';
import { parseBannerList } from 'helpers/parseBannerList';

import { Slider } from '@atlas/components';
import { SiteConfigManager, useApplicationState, useBannerList } from '@atlas/core';

import { filterBannersList } from 'common/utils/filterBannersList';
import { useIsRtl } from 'hooks/useIsRtl';

export const SportsbookBanner = ({ className }) => {
  const { authenticated } = useApplicationState();
  const isRtl = useIsRtl();
  const { bannerList } = useBannerList(
    SiteConfigManager.getConfig('config.config.sportsbook.mobile_banner_group'),
    'MOBILE',
  );

  const banners = useMemo(() => parseBannerList(bannerList), [bannerList]);
  const dir = useMemo(() => (isRtl ? 'rtl' : 'ltr'), [isRtl]);

  const filteredBanners = useMemo(
    () => filterBannersList(banners, authenticated),
    [authenticated, banners],
  );

  if (!filteredBanners.length) return null;

  return (
    <Slider className={className} dir={dir} loop={filteredBanners.length > 1} slidesPerView={1}>
      {filteredBanners.map(({ href, imageUrl, target, title }) => (
        <Slider.Slide className="sportsbook-banner-slide" key={`${imageUrl}${href}${target}`}>
          <Slider.Banner href={href} imageUrl={imageUrl} small target={target} title={title} />
        </Slider.Slide>
      ))}
    </Slider>
  );
};
